import React from 'react';
import { AboutPageLayout } from '../Layout';
import styles from './WhoNeeds.module.scss';

export const WhoNeedsStepOneSection = () => (
  <AboutPageLayout
    leftContent={
      <div className={styles.leftSection}>
        <div className={styles.stepSection_1}>
          Who <span>needs</span>
        </div>
        <div className={styles.stepSection_2}>
          Transparen <br /> Terra?
        </div>
      </div>
    }
    rightContent={
      <div className={styles.stepContent}>
        TransparenTerra brings together like-minded people who are concerned about the future of the
        planet and the prosperity of future generations.
      </div>
    }
  />
);
